<footer class="pr-5 mt-5 d-flex align-items-center justify-content-end">
    <div class="cgu-container pointer" (click)="_cguService.openCGU()">CGU</div>
    @Copyright TotalEnergies
    
</footer>